// frontend/src/components/common/GlobalUiHost.js
//
// Renders the global snackbar + confirm dialog surfaces driven by
// NotificationContext (decision D17: reuse NotificationContext).
//
// This host lives inside the MUI ThemeProvider (mounted from the app shell in
// App.js) so the Snackbar/Alert/Dialog pick up the active theme. State and the
// imperative helpers (showSnackbar / confirm) live in NotificationContext.
//
// Wave 1 note: additive. Existing hand-rolled <Snackbar> components and
// window.confirm call sites are migrated in a later wave; this host simply
// provides the shared surface for them to move onto.

import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useNotifications } from '../../context/NotificationContext';
import ConfirmDialog from './ConfirmDialog';

export default function GlobalUiHost() {
  const {
    snackbar,
    closeSnackbar,
    confirmState,
    handleConfirm,
    handleCancelConfirm,
  } = useNotifications();

  return (
    <>
      <Snackbar
        open={!!snackbar?.open}
        autoHideDuration={4000}
        onClose={(event, reason) => {
          if (reason === 'clickaway') return;
          closeSnackbar();
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={closeSnackbar}
          severity={snackbar?.severity || 'success'}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar?.message}
        </Alert>
      </Snackbar>

      <ConfirmDialog
        open={!!confirmState?.open}
        title={confirmState?.title}
        message={confirmState?.message}
        confirmText={confirmState?.confirmText}
        cancelText={confirmState?.cancelText}
        confirmColor={confirmState?.confirmColor}
        onConfirm={handleConfirm}
        onCancel={handleCancelConfirm}
      />
    </>
  );
}
